import instance from './instances/plagiarism-service';

export function getPlagiarismPreviewHTML(url) {
    return instance.get(`/v1/plagiarism/match/preview?s3_path=${url}`);
}
